import { useFlags } from "launchdarkly-react-client-sdk";
import { flagDefaults, type FlagKey } from "@ld-scorecard/shared";

/**
 * Read a boolean flag by its exact LaunchDarkly key. The provider is configured
 * with useCamelCaseFlagKeys: false, so keys match the dashboard verbatim.
 * Falls back to the shared default when the flag/provider is unavailable.
 */
export function useFlag(key: FlagKey): boolean {
  const flags = useFlags();
  const value = flags[key];
  return value === undefined ? (flagDefaults[key] ?? true) : Boolean(value);
}

export { FLAGS } from "@ld-scorecard/shared";
